import { useMutation } from '@apollo/client';
import { gql } from '__generated__';
import { FC } from 'react';

import ConfirmButton from 'components/ConfirmButton';

const GENERATE_IDENTITY_CARDS_MUTATION = gql(`
  mutation GenerateUserReportForDepartment($departmentId: ID!) {
    generateUserReportForDepartment(departmentId: $departmentId) {
      id
      status
      url
    }
  }
`);

const GenerateUserReportForDepartment: FC<{ departmentId: string }> = ({ departmentId }) => {
  const [generateUserReportForDepartment, { loading, error }] = useMutation(
    GENERATE_IDENTITY_CARDS_MUTATION,
    {
      variables: { departmentId },
      onCompleted: data => {
        if (data.generateUserReportForDepartment.status === 'ACTIVE') {
          window.open(data.generateUserReportForDepartment.url as string, '_blank');
        }
      },
    }
  );

  return (
    <ConfirmButton
      title="Generate User Report"
      description="Are you sure you want to generate a user report for this department?"
      loading={loading}
      error={error}
      onConfirm={generateUserReportForDepartment}
    >
      Generate User Report
    </ConfirmButton>
  );
};

export default GenerateUserReportForDepartment;
